/**
 * @generated SignedSource<<7f558f9f4c79e8eb3620cb35a52ba61e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useSignSmartWalletClaimQuery$variables = {
  identifier: string;
};
export type useSignSmartWalletClaimQuery$data = {
  readonly profile: {
    readonly id?: string;
    readonly smartWallet?: {
      readonly smartWalletConfig: {
        readonly owners: ReadonlyArray<{
          readonly ownerAddress: any;
          readonly ownerIndex: number;
        }> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useSignSmartWalletClaimQuery = {
  response: useSignSmartWalletClaimQuery$data;
  variables: useSignSmartWalletClaimQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "identifier"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "identifier",
    "variableName": "identifier"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "GraphQLSmartWalletOwner",
  "kind": "LinkedField",
  "name": "owners",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ownerAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ownerIndex",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSignSmartWalletClaimQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLLinkedWalletProfile",
                "kind": "LinkedField",
                "name": "smartWallet",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphQLSmartWalletProfile",
                    "kind": "LinkedField",
                    "name": "smartWalletConfig",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "GraphQLAccountProfile",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSignSmartWalletClaimQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLLinkedWalletProfile",
                "kind": "LinkedField",
                "name": "smartWallet",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphQLSmartWalletProfile",
                    "kind": "LinkedField",
                    "name": "smartWalletConfig",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "GraphQLAccountProfile",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1cdccf2932046799b60d104e7f9c877e",
    "id": null,
    "metadata": {},
    "name": "useSignSmartWalletClaimQuery",
    "operationKind": "query",
    "text": "query useSignSmartWalletClaimQuery(\n  $identifier: String!\n) {\n  profile(identifier: $identifier) {\n    __typename\n    ... on GraphQLAccountProfile {\n      id\n      smartWallet {\n        smartWalletConfig {\n          owners {\n            ownerAddress\n            ownerIndex\n          }\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1c8b4b6634616318f3809b991868c109";

export default node;
